import { ApiCall } from '../../../../../../submodules/web-shared/services/http-service/types/ApiCall';
import httpService from '../../../../../../submodules/web-shared/services/http-service';
import { UpdateCompanySSOSettingsParams } from '../types/UpdateCompanySSOSettingsParams';
import { CompanySSOSettingsData } from './types/CompanySSOSettingsData';
import { PublicCompanySSOConfig } from './types/PublicCompanySSOConfig';

export const getCompanySSOSettings: ApiCall<{ id: number }, CompanySSOSettingsData> = async ({ params, abortSignal }) => {
  const { data } = await httpService.get(`/api/v3/company_management/companies/${params.id}/sso_setting`, null, abortSignal);
  return data;
};

export const updateCompanySSOSettings: ApiCall<UpdateCompanySSOSettingsParams, CompanySSOSettingsData> = async ({ params, abortSignal }) => {
  const { data } = await httpService.put(`/api/v3/company_management/companies/${params.id}/sso_setting`, params, abortSignal);
  return data;
};

export const getPublicCompanySSOConfig: ApiCall<undefined, PublicCompanySSOConfig> = async ({ abortSignal }) => {
  const { data } = await httpService.get('/api/v3/public/sso_setting', null, abortSignal);
  return data;
};
